var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotificationIcons = void 0;
var CommentingNotificationIcon_1 = require("./commenting/CommentingNotificationIcon");
var ExtractNotificationIcon_1 = require("./extract/ExtractNotificationIcon");
var FlowNotificationIcon_1 = require("./flow/FlowNotificationIcon");
var SharingNotificationIcon_1 = require("./sharing/SharingNotificationIcon");
var UserNotificationType_1 = require("./UserNotificationType");
exports.NotificationIcons = (_a = {},
    _a[UserNotificationType_1.UserNotificationType.Commenting] = CommentingNotificationIcon_1.commentingNotificationIcon,
    _a[UserNotificationType_1.UserNotificationType.CreateExtractFailure] = ExtractNotificationIcon_1.extractFailureNotificationIcon,
    _a[UserNotificationType_1.UserNotificationType.RefreshExtractSuspension] = ExtractNotificationIcon_1.extractSuspensionNotificationIcon,
    _a[UserNotificationType_1.UserNotificationType.RefreshExtractFailure] = ExtractNotificationIcon_1.extractFailureNotificationIcon,
    _a[UserNotificationType_1.UserNotificationType.FlowCompleted] = FlowNotificationIcon_1.flowFailureNotificationIcon,
    _a[UserNotificationType_1.UserNotificationType.Sharing] = SharingNotificationIcon_1.sharingNotificationIcon,
    _a[UserNotificationType_1.UserNotificationType.CreateExtractSucceededV2] = ExtractNotificationIcon_1.extractSuccessNotificationIcon,
    _a);
//# sourceMappingURL=NotificationIcons.js.map